var map = {
	"./Advisors/advisor-01.png": 5687,
	"./Advisors/advisor-02.png": 5741,
	"./Advisors/advisor-03.png": 475,
	"./Associates/assirience.png": 1169,
	"./Associates/jsa.png": 8615,
	"./Background/contact-bg.jpg": 1982,
	"./Background/cta-bg-1.png": 5126,
	"./Background/cta-bg-2.png": 1426,
	"./Background/cta-bg-3.png": 9614,
	"./Background/soft-s5-bg.webp": 3416,
	"./Background/title-bar-01-bg.jpg": 337,
	"./Banner/banner-01.png": 4414,
	"./Banner/banner-02.png": 2660,
	"./Banner/banner-03.png": 9405,
	"./Banner/banner-04.png": 4718,
	"./Banner/banner-05.png": 793,
	"./Clients/allied-axiom-hover.png": 2853,
	"./Clients/allied-axiom.png": 8632,
	"./Clients/aura-hover.png": 5444,
	"./Clients/aura.png": 3009,
	"./Clients/bus-caro-hover.png": 4115,
	"./Clients/bus-caro.png": 4039,
	"./Clients/danpak-hover.png": 9747,
	"./Clients/danpak.png": 9669,
	"./Clients/dipitt-hover.png": 4715,
	"./Clients/dipitt.png": 8358,
	"./Clients/kings-hover.png": 6791,
	"./Clients/kings.png": 8742,
	"./Clients/noon-hover.png": 7123,
	"./Clients/noon.png": 9718,
	"./Clients/pms-hover.png": 8449,
	"./Clients/pms.png": 4362,
	"./Clients/sitech-hover.png": 6573,
	"./Clients/sitech.png": 7050,
	"./Clients/techexeons-hover.png": 4300,
	"./Clients/techexeons.png": 658,
	"./Clients/vsolar-hover.png": 9883,
	"./Clients/vsolar.png": 4384,
	"./Clients/zamanat-hover.png": 9249,
	"./Clients/zamanat.png": 349,
	"./Customer/customer-1.jpg": 3314,
	"./Customer/customer-2.jpg": 6238,
	"./Customer/customer-3.jpg": 6034,
	"./Customer/customer-4.jpg": 6697,
	"./Customer/customer-5.jpg": 4363,
	"./Events/ITCN/img-1.jpg": 675,
	"./Events/ITCN/img-10.jpg": 982,
	"./Events/ITCN/img-2.jpg": 4245,
	"./Events/ITCN/img-3.jpg": 401,
	"./Events/ITCN/img-4.jpg": 2675,
	"./Events/ITCN/img-5.jpg": 4002,
	"./Events/ITCN/img-6.jpg": 4857,
	"./Events/ITCN/img-7.jpg": 5098,
	"./Events/ITCN/img-8.jpg": 6991,
	"./Events/ITCN/img-9.jpg": 9596,
	"./Hero/hero-01.png": 3593,
	"./Hero/hero-02.png": 277,
	"./Hero/hero-03.png": 5682,
	"./Hero/hero-04.png": 2211,
	"./Icons/advantage.png": 9233,
	"./Icons/agile.png": 4751,
	"./Icons/business-development.png": 1317,
	"./Icons/collaboration.png": 9051,
	"./Icons/communication.png": 5578,
	"./Icons/customer-satisfaction.png": 7688,
	"./Icons/dashboard.png": 5692,
	"./Icons/documentation.png": 8556,
	"./Icons/finance.png": 9902,
	"./Icons/freight-and-forwarding.png": 2030,
	"./Icons/green-curve-arrow.png": 4495,
	"./Icons/guidance.png": 672,
	"./Icons/hero-selector-icon.png": 7700,
	"./Icons/hr-management.png": 6317,
	"./Icons/improvement.png": 794,
	"./Icons/inventory-management.png": 6515,
	"./Icons/light-close.png": 6086,
	"./Icons/market-reach.png": 6832,
	"./Icons/marketing.png": 106,
	"./Icons/plant-maintenance.png": 8792,
	"./Icons/production.png": 3668,
	"./Icons/productivity.png": 1213,
	"./Icons/property-management.png": 5784,
	"./Icons/purchase-management.png": 2485,
	"./Icons/quote.png": 6717,
	"./Icons/sales-management.png": 5998,
	"./Icons/selector-icon.png": 8276,
	"./Icons/service-management.png": 9799,
	"./Icons/solution.png": 7482,
	"./Icons/support.png": 4787,
	"./Icons/technology.png": 9499,
	"./Logo/dark-logo.png": 3300,
	"./Logo/white-logo.png": 3693,
	"./Partners/xpeditesol.png": 6297,
	"./contact-us.png": 2245,
	"./profile.png": 1633,
	"./soft-s5-img.webp": 8869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4254;